import React from 'react';
import { Question } from 'types/questionnaire/types';

interface AgreeQuestionProps {
  question: Question;
  value: boolean | undefined;
  onChange: (value: boolean) => void;
  error?: string;
  stopWarning?: boolean;
  loading?: boolean;
}

const AgreeQuestion: React.FC<AgreeQuestionProps> = ({ question, onChange, error, stopWarning, loading }) => {
  const agreeLabel = question.agreeLabel || 'Yes, I agree';
  return (
    <div className="question-agreement flex flex-col gap-3">
      <p className="text-lg font-semibold leading-7 tracking-tight text-brand-black">{question.text}</p>
      {question.description && <p className="text-sm text-brand-black/80">{question.description}</p>}
      {question.content && (
        <div className="question-agreement-content">
          {question.content.map((item, idx) => (
            <p key={idx} className="text-[15px] text-brand-black/95">
              {item}
            </p>
          ))}
        </div>
      )}
      {stopWarning && (
        <div className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700">
          Unfortunately based on this answer, you are not suitable for ED treatment, please choose a different answer if
          appropriate or contact us for medical advice
        </div>
      )}
      <button
        type="button"
        className={`rounded-lg border px-4 py-2 text-sm font-semibold border-talo-dark-green bg-talo-dark-green text-white mt-3`}
        onClick={() => onChange(true)}
        disabled={loading}
      >
        {loading ? (
          <span className="inline-flex h-4 w-4 animate-spin rounded-full border-2 border-white/70 border-t-white" />
        ) : (
          agreeLabel
        )}
      </button>
      {error && <p style={{ color: 'red', fontSize: '0.875rem' }}>{error}</p>}
    </div>
  );
};

export default AgreeQuestion;
